/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-c445dc73.js';
import React__default from 'react';
import '../_chunks/dep-5cf1fbb1.js';
import '../_chunks/dep-f771ed13.js';

var _eventToPropRecord;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var PropagationEvent = /* @__PURE__ */function (PropagationEvent2) {
  PropagationEvent2["CLICK"] = "click";
  PropagationEvent2["SCROLL"] = "scroll";
  return PropagationEvent2;
}(PropagationEvent || {});
var eventToPropRecord = (_eventToPropRecord = {}, _defineProperty(_eventToPropRecord, "click" /* CLICK */, "onClick"), _defineProperty(_eventToPropRecord, "scroll" /* SCROLL */, "onScroll"), _eventToPropRecord);
function withStopPropagation(events, element) {
  var props = _objectSpread({}, element.props);
  if (!events.length) return element;
  var _iterator = _createForOfIteratorHelper(events),
    _step;
  try {
    var _loop = function _loop() {
      var key = _step.value;
      var prop = eventToPropRecord[key];
      props[prop] = function (e) {
        var _element$props$prop, _element$props;
        e.stopPropagation();
        (_element$props$prop = (_element$props = element.props)[prop]) === null || _element$props$prop === void 0 ? void 0 : _element$props$prop.call(_element$props, e);
      };
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return /*#__PURE__*/React__default.cloneElement(element, props);
}

export { PropagationEvent, withStopPropagation as default, withStopPropagation };
//# sourceMappingURL=withStopPropagation.js.map
